import aspetto_logo from "../assets/Aspetto_Login.png";

export { aspetto_logo };

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CRYPTO_SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;
export const IV_LENGTH = process.env.REACT_APP_IV_LENGTH;
export const isEncryption = Boolean(process.env.REACT_APP_ENCRYPTION);

export const roleColors = {
  1: "btn-primary",
  2: "btn-yellow",
  3: "btn-success",
  4: "btn-purple",
};

export const API_ENDPOINTS = {
  LOGIN: "auth/login",
  OTP_VERIFICATION: "auth/login-otp-verification",
  REGISTER: "auth/register",
  VERIFY_EMAIL: "auth/verify",
  RESEND_EMAIL: "auth/resend-verification",
  RESET_PASSWORD: "auth/password-reset",
  RESET_PASSWORD_EMAIL: "auth/password-reset-mail",
  RESET_USERNAME: "auth/forget-username",
  CHECK_TOKEN: "auth/check-token",
  GET_ROLES: "roles/fetch-roles",
  POST_ROLES: "roles/create-role",
  UPDATE_ROLE: "roles/update-role",
  GET_PERMISSIONS: "roles/fetch-permissions",
  UPDATE_PERMISSIONS: "roles/assign-permission",
  GET_USERS: "users/get-users",
  DELETE_USER: "users/delete-user",
  DEACTIVATE_USER: "users/update-user-status",
  GET_USER_DETAILS: "roles/fetch-user-permissions",
  ASSIGN_ROLES: "/users/assign-roles",

  CREATE_BUG: "/bug/create",
  UPDATE_BUG: "/bug/update",
  DELETE_BUG: "/bug/delete",
  UPDATE_BUG_PRIORITY: "/bug/update-status",
  GET_BUGS: "/bug/listing",
  GET_SINGLE_BUG: "/bug/single",
  ADD_COMMENTS: "/bug/create-comment",
  GET_LAST_COMMENT: "/bug/last-comment",

  GET_VENDORS: "vendors/get-vendors",
  GET_SINGLE_VENDOR: "vendors/get-single-vendor",
  VENDOR_EXCEL_DOWNLOAD: "vendors/vendors/export",
  ADD_UPDATE_VENDORS: "vendors/add-or-update-vendor",
  UPDATE_VENDORS_WITHOUT_QUICKBOOK: "vendors/update",
  VENDOR_STATUS: "vendors/vendor-status-update",
  GET_VENDOR_PRODUCTS: "vendors/get-vendor-products",
  CREATE_CONTRACT: "/contract_type/create",
  GET_PRODUCTS: "/common/search-products-cv",
  UPDATE_CONTRACT: "/contract_type/update",
  GET_CONTRACT: "/contract_type/fetch",
  GET_PARENT_CONTRACT: "contract_type/fetch-parent",
  CHANGE_CONTRACT_STATUS: "/contract_type/update-status",
  VALIDATE_CONTRACTNAME: "/contract_type/validate-name",
  GET_SINGLE_VEHICLE: "/contract_type/get-single",
  CREATE_RFQ: "/rfq/create",
  UPDATE_RFQ: "/rfq/update",
  COPY_RFQ: "/rfq/copy",

  GET_RFQ_USERS: "/common/get-sales-users",
  GET_ALL_USERS: "common/get-all-users",
  GET_CUSTOMER_AUTOFILL: "/common/search-customers-autofill",
  GET_UOI_AUTOFILL: "/common/get-uoi",
  GET_KIT_PRODUCT: "/common/search-kit",
  GET_ORDER_VERIFICATION: "/common/verify-customer-rma-order",
  SEARCH_QUICKBOOK_VENDOR: "/common/search-quickbook-vendors",
  LINK_QUICKBOOK_VENDOR: "/common/link-quickbook-vendors",
  EDIT_ORDERID: "/common/update-module-unique-id",

  // UPLOAD_RFQ_IMG: "/rfq/upload",
  OPPORTUNITY_STATUS: "/rfq/update-status",
  GET_PURCHASE_DATA: "/common/search-products-purchase-tab",
  LISTING_OPPORTUNITIES: "/rfq/listing",
  PRODUCT_SUGGETION: "common/search-products",
  GET_SINGLE_RFQ: "rfq/single",
  GET_VERSION_RFQ: "rfq/get-product-revision",
  DELETE_RECORD_RFQ: "rfq/delete-opportunity",
  SYNC_TRANSACTIONID_RFQ: "/rfq/mannual-payment-authorize",
  SYNC_CUSTOMERS_RFQ: "/rfq/sync-quickbook-invoice-salesreceipt",
  UPDATE_PRODUCTS_RFQ: "/rfq/update-rfq-products",
  OPPORTUNITY_EXCEL_DOWNLOAD: "/rfq/opportunity/export",

  GET_RFQ_REVISION_HISTORY: "rfq/get-revision",
  UPLOAD_PRODUCT_CSV: "/product-import/upload",
  GET_IMPORT_BATCH_ROWS: "/product-import/get-imports",
  EXPORT_CSV: "/product-import/export-missing",
  IMPORT_CSV: "/product-import/resubmit-missing",
  APPROVE_IMPORT_BATCH: "/product-import/approve-imports",
  ADD_SKU: "/product/create",
  UPDATE_SKU: "/product/update",
  GET_SKU_LISTING: "/product/fetch",
  VALIDATE_SKUID: "product/validate-sku",
  GET_PRODUCTS_INFO: "product/get-product-usage",
  UPDATE_PRODUCT_INFO: "product/update-product-usage",
  DELETE_PRODUCT: "product/delete-product",
  UPDATE_SKU_ID: "product/update-sku",
  SINGLE_SKU: "/product/single",
  PRODUCT_EXCEL_DOWNLOAD: "/product/product/export",
  EMAIL_ALL_USERS: "/users/get-email-all-users",
  SEND_QUOTE_EMAIL: "/rfq/quote-email-handler",
  SEND_EMAIL_KO_CUSTOMER: "/rfq/customer-email-handler",
  EMAIL_HISTORY: "/rfq/customer-email-history",

  CREATE_CONTACT: "/contact/create",
  BULK_UPLOAD_PRODUCT: "/product/upload-from-excel",
  ADD_UPDATE_CUSTOMER: "/customers/add-or-update",
  UPDATE_CUSTOMER_WITHOUT_QUICKBOOK: "/customers/update",
  GET_CUSTOMER: "/customers/get",
  GET_SINGLE_CUSTOMER: "/customers/get-single",
  CUSTOMER_STATUS_UPDATE: "/customers/status-update",
  CREATE_CARD_INFO: "/customers/create-card-info",
  GET_CARD_INFO: "/customers/get-card-info",
  DELETE_CARD_INFO: "/customers/delete-card-detail",
  GENERATE_REGISTER_LINK: "/customers/generate-register-link",
  VERIFY_REGISTER_TOKEN: "/customers/verify-register-link",
  CUSTOMER_EXCEL_DOWNLOAD: "customers/customers/export",
  ADD_PUBLIC_CUSTOMER: "customers/add-secure-customer",
  // UPLOAD_ATTACHMENTS: "/customers/upload",
  REMOVE_ATTACHMENTS: "/customers/remove-file",
  GET_CARD_INFO_VENDOR: "/vendors/get-card-info",
  CREATE_CARD_INFO_VENDOR: "/vendors/create-card-info",
  DELETE_CARD_INFO_VENDOR: "/vendors/delete-card-detail",
  VERIFY_CUSTOMER_EMAIL: "/customers/generate-card-link",
  VERIFY_TOKEN: "/customers/verify-card-link",
  CREATE_CARD_INFO_EXTERNAL: "/customers/add-secure-card",

  COPY_ATTACHMENTS: "/attachment/copy-file",
  VIEW_ATTACHMENTS: "/attachment/view",
  UPLOAD_ATTACHMENTS: "/attachment/upload",
  FETCH_ATTACHMENTS: "/attachment/fetch",
  REMOVE_ATTACHMENT: "attachment/remove-file",
  UPDATENAME_ATTACHMENT: "/attachment/update-name",
  DOWNLOAD_ALL_ATTACHMENTS: "/attachment/download-all",
  UPLOAD_ATTACHMENTS_PUBLICRMA: "/attachment/upload/customer",
  FETCH_ATTACHMENTS_PUBLICRMA: "/attachment/fetch/customer",
  REMOVE_ATTACHMENT_PUBLICRMA: "/attachment/remove-file/customer",
  UPDATENAME_ATTACHMENT_PUBLICRMA: "/attachment/update-name/customer",
  VIEW_ATTACHMENT_PUBLICRMA: "/attachment/view/customer",
  CREATE_NOTES: "/note/create",
  GET_NOTES: "/note/fetch",
  REMOVE_NOTE: "/note/remove-note",
  REMOVE_SECTION: "/note/remove-section",
  UPDATE_SINGLE_NOTE: "note/update-single",
  CREATE_NOTES_PUBLICRMA: "/note/create/customer",
  GET_NOTES_PUBLICRMA: "/note/fetch/customer",
  REMOVE_NOTE_PUBLICRMA: "/note/remove-note/customer",
  REMOVE_SECTION_PUBLICRMA: "/note/remove-section/customer",
  UPDATE_SINGLE_NOTE_PUBLICRMA: "/note/update-single/customer",

  ORDER_CREATE: "/order/create",
  ORDER_LIST: "/order/listing",
  ORDER_LIST_NEW: "/order/listing-by-department",
  GET_SINGLE_ORDER: "order/single",
  COPY_ORDER: "/order/copy",
  UPDATE_ORDER: "/order/update",
  DELETE_RECORD_ORDER: "order/delete-order",
  GET_ORDER_REVISION_HISTORY: "/order/get-revision",
  GET_ORDER_PRODUCT_REVISION_HISTORY: "/order/get-product-revision",
  SEND_ORDER_EMAIL: "/order/quote-email-handler",
  EMAIL_HISTORY_ORDER: "/order/customer-email-history",
  SEND_EMAIL_KO_CUSTOMER_ORDER: "/order/customer-email-handler",
  PACKING_SLIP_EMAIL: "/order/attachments-packaging-slip/send-email",
  GET_DATA_VIA_PROJECTID: "/order/get-opportunity-project",
  FINANCE_STATUS_CHANGE: "/order/change-finance-statuses",
  ORDER_STATUS: "/order/update-status",
  ORDER_EXCEL_DOWNLOAD: "/order/orders/export",
  DownLoadFile: "/common/download",
  GET_VALID_IDS: "/order/get-eligible-oppotunity_ids",
  SYNC_QUICK_BOOK: "/order/auto-tick-chain-of-custody",
  SYNC_CUSTOMERS: "/order/sync-sales-receipt-quickbook",
  SYNC_TRANSACTIONID: "/order/mannual-payment-authorize",
  SYNC_BILL_PO: "/order/mannual-payment-bill-po",
  GENERATE_FEEDBACK_LINK: "/order/generate-feedback-link",
  VERIFY_FEEDBACK_TOKEN: "/order/verify-feedback-link",
  SUBMIT_FEEDBACK: "/order/add-feedback",
  PUBLIC_ORDER_STATUS: "/public/order-status",
  FEEDBACK_LISTING: "/order/list-feedback",
  GET_SINGLE_FEEDBACK: "/order/list-single-feedback",
  GET_PENDING_STEPS: "/order/get-pending-coc",
  GET_PACKING_SLIP: "/order/get-packaging-slip",
  GET_PDF_PACKING_SLIP: "/order/generate-packaging-slip/send-email",
  DELETE_PACKING_SLIP: "/order/delete-packaging-slip",
  GENERATE_PACKING_SLIP: "/order/generate-packaging-slip",
  CHANGE_STATUS_COC: "/order/manual-check-chain-of-custody",
  GET_CUSTOMER_CARD: "/customers/get-cards",
  GET_CARDS_LISTING: "/card/listing",
  SEND_OTP_CARDS: "card/send-otp-edit-card",
  VERIFY_CARDS_OTP: "card/verify-otp-edit-card",
  UPDATE_CARD_DETAILS: "card/update-detail-card",
  PAYMENT_OTP: "/authorize/create-payment-otp",
  VERIFY_PAYMENT_OTP: "authorize/create-payment",
  GSA_PDF: "/order/read-gsa-order-pdf",

  CREATE_RMA: "/rma/create",
  UPDATE_RMA: "/rma/update",
  RMA_LIST: "rma/listing",
  GET_SINGLE_RMA: "rma/single",
  GET_RMA_REVISION_HISTORY: "/rma/get-revision",
  RMA_STATUS: "/rma/update-status",
  CREATE_PUBLICRMA: "/rma/create/customer",
  UPDATE_PUBLICRMA: "/rma/update/customer",
  GET_SINGLE_PUBLICRMA: "/rma/single/customer",
  SUBMIT_INVESTIGATION: "/rma/update-investigation",
  SUBMIT_RESOLUTION: "/rma/update-resolution",
  SUBMIT_FOLLOWUP: "/rma/update-followup",
  REOPEN_RMA: "/rma/update-reopen",
  CLOSE_RMA: "/rma/update-close",
  RMA_STATUS: "/rma/update-status",
  SEND_EMAIL_KO_CUSTOMER_RMA: "/rma/customer-email-handler",
  EMAIL_HISTORY_RMA: "/rma/customer-email-history",
  SEND_RMA_EMAIL: "/rma/quote-email-handler",

  CREATE_PROJECT: "/project/create",
  UPDATE_PROJECT: "/project/update",
  PROJECT_EXPORT: "/project/products/export",
  GET_SINGLE_PROJECT: "/project/single",
  GET_PRICE_CHANGES: "/project/list-price-changes",
  LISTING_PROJECT: "/project/listing",
  GET_VERSION_PROJECT: "/project/get-product-revision",
  GET_PROJECT_REVISION_HISTORY: "project/get-revision",
  EMAIL_HISTORY_PROJECT: "/project/customer-email-history",
  SEND_PROJECT_EMAIL: "/project/quote-email-handler",
  PROJECT_STATUS: "/project/update-status",
  SEND_EMAIL_KO_CUSTOMER_PROJECT: "/project/customer-email-handler",
  PRICE_CHANGES: "/project/update-price-changes",
  KIT_PRICE_CHANGES_LISTING: "/project/get-rfq-kit-products",
  KIT_PRICE_CHANGES_UPDATE: "/project/update-kit-price-changes",




  // FBOP MODULE
  FBOP_LISTING: "/fbop/index",
  UPLOAD_PDF: "/fbop/uploadPdf",
  GET_SINGLE_FBOP: "/fbop/pdf/index",
  UPDATE_SINGLE_FBOP: "fbop/update-fbop-form-data",
  DELETE_SINGLE_FBOP: "fbop/delete-single-fbop-attachment",
  GET_FBOP_PRODUCTS: "/fbop/get-fbop-products",
};

export const NAV_ITEMS = [
  // {
  //   id: 1,
  //   title: "home",
  //   iconName: "IconHomeIcon",
  // },
  {
    id: 2,
    title: "Opportunities",
    iconName: "IconFileText",
    permission: "manage_rfq",
    items: [
      {
        id: 1,
        name: "Create an Opportunity",
        path: "/create-rfq",
        action: "write",
      },
      {
        id: 2,
        name: "Opportunities",
        path: "/list-opportunities",
        action: "read",
      },
      { id: 3, name: "Multi-Variant Quote", path: "/" },
      { id: 4, name: "Retrieve/Update", path: "/" },
      { id: 5, name: "Upload PDF(GSA)", path: "/" },
    ],
  },
  {
    id: 3,
    title: "RFIs",
    iconName: "InfoHexagon",
    permission: "manage_rfi",
    items: [
      { id: 1, name: "New RFI", path: "/", disabled: false },
      { id: 2, name: "Retrieve/Update", path: "/", disabled: false },
    ],
  },
  // {
  //   id: 4,
  //   title: "RMAs",
  //   iconName: "ShieldStar",
  //   permission: "manage_rma",
  //   items: [
  //     { id: 1, name: "New RMA", path: "/", disabled: true },
  //     { id: 2, name: "Retrieve/Update", path: "/", disabled: true },
  //   ],
  // },
  {
    id: 4,
    title: "Drafts",
    iconName: "Notes",
    permission: "manage_draft",
    items: [{ id: 1, name: "RFQ Drafts", path: "/", disabled: true }],
  },
  {
    id: 5,
    title: "Orders",
    iconName: "IconReceipt",
    permission: "manage_orders",
    items: [
      {
        id: 1,
        name: "Create an Order",
        path: "/create-order-lifecycle",
        action: "write",
      },
      {
        id: 2,
        name: "Orders",
        path: "/list-order-lifecycle",
        action: "write",
      },
      {
        id: 3,
        name: "Customer Reviews",
        path: "/list-customer-reviews",
        action: "write",
      },
      // { id: 2, name: "FBOP", path: "/" },
      // { id: 3, name: "GSA", path: "/" },
      // { id: 4, name: "DHS-CBP", path: "/" },
    ],
  },
  {
    id: 6,
    title: "Vendors",
    iconName: "IconUserDollar",
    permission: "manage_vendors",
    items: [
      {
        id: 1,
        name: "Create a Vendor",
        path: "/create-vendor",
        action: "write",
      },
      { id: 1, name: "Vendors", path: "/vendor", action: "read" },
    ],
  },
  {
    id: 7,
    title: "Customers",
    iconName: "IconUsers",
    permission: "manage_customers",
    items: [
      {
        id: 1,
        name: "Create a Customer",
        path: "/create-customer",
        action: "write",
      },
      {
        id: 1,
        name: "Customers",
        path: "/customer-list",
        action: "read",
      },
      {
        id: 1,
        name: "Payment Cards",
        path: "/payment-cards",
        action: "read",
      },
    ],
  },
  {
    id: 8,
    title: "Products",
    iconName: "IconBrandCodesandbox",
    permission: "manage_products",
    items: [
      {
        id: 1,
        name: "Create a Product",
        path: "/create-product",
        action: "write",
      },
      // {
      //   id: 1,
      //   name: "Import Bulk Products",
      //   path: "/create-bulk-product",
      //   action: "write",
      // },
      { id: 2, name: "Products", path: "/products-list", action: "read" },
    ],
  },
  {
    id: 9,
    title: "RMAs",
    iconName: "Return",
    permission: "manage_rma",
    items: [
      {
        id: 1,
        name: "Create an RMA",
        path: "/create-rma",
        action: "write",
      },
      {
        id: 2,
        name: "RMAs",
        path: "/list-rma",
        action: "write",
      },
    ],
  },
  {
    id: 10,
    title: "Contract Vehicles",
    iconName: "Return",
    permission: "manage_project",
    items: [
      {
        id: 1,
        name: "Create a Contract Vehicle",
        path: "/create-contract-vehicle",
        action: "write",
      },
      {
        id: 2,
        name: "Contract Vehicles",
        path: "/list-contract-vehicles",
        action: "write",
      },
    ],
  },
  // {
  //   id: 11,
  //   title: "Automations",
  //   iconName: "IconFileTextAi",
  //   permission: "manage_orders",
  //   items: [
  //     {
  //       id: 1,
  //       name: "FBOP Form Validator",
  //       path: "/list-fbop",
  //       action: "write",
  //     },
  //     {
  //       id: 2,
  //       name: "DHS Form Validator",
  //       path: "/list-fbop",
  //       action: "write",
  //     },
  //   ],
  // },
  // {
  //   id: 12,
  //   title: "Help Assistant (Beta)",
  //   iconName: "IconMessageChatbot",
  //   permission: "manage_orders",
  //   items: [
  //     {
  //       id: 1,
  //       name: "Open AI Chat",
  //       path: "https://chatgpt.com/g/g-69fdd97f30308191a3d494f88dcbe875-aspetto-crm-faq",
  //       action: "write",
  //     },
  //   ],
  // },
];

export const TERMS = {
  Term: [
    {
      Name: "Due at time of order",
      Active: true,
      Type: "STANDARD",
      DueDays: 0,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "1",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 10",
      Active: true,
      Type: "STANDARD",
      DueDays: 10,
      domain: "QBO",
      sparse: false,
      Id: "5",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-14T15:24:26-08:00",
        LastUpdatedTime: "2024-11-14T15:24:26-08:00",
      },
    },
    {
      Name: "NET 15",
      Active: true,
      Type: "STANDARD",
      DueDays: 15,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "2",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 30",
      Active: true,
      Type: "STANDARD",
      DueDays: 30,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "3",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 45",
      Active: true,
      Type: "STANDARD",
      DueDays: 30,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "0",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 60",
      Active: true,
      Type: "STANDARD",
      DueDays: 60,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "4",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "Other",
      Active: true,
      Type: "STANDARD",
      DueDays: 60,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "10",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
  ],
};

export const TERMSVENDOR = {
  Term: [
    {
      Name: "Due on receipt",
      Active: true,
      Type: "STANDARD",
      DueDays: 0,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "1",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 10",
      Active: true,
      Type: "STANDARD",
      DueDays: 10,
      domain: "QBO",
      sparse: false,
      Id: "5",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-14T15:24:26-08:00",
        LastUpdatedTime: "2024-11-14T15:24:26-08:00",
      },
    },
    {
      Name: "NET 15",
      Active: true,
      Type: "STANDARD",
      DueDays: 15,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "2",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 30",
      Active: true,
      Type: "STANDARD",
      DueDays: 30,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "3",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
    {
      Name: "NET 60",
      Active: true,
      Type: "STANDARD",
      DueDays: 60,
      DiscountDays: 0,
      domain: "QBO",
      sparse: false,
      Id: "4",
      SyncToken: "0",
      MetaData: {
        CreateTime: "2024-11-09T14:41:49-08:00",
        LastUpdatedTime: "2024-11-09T14:41:49-08:00",
      },
    },
  ],
};

// prevent type - e + in input number

// export const handleKeyDown = (evt) => {
//   if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
//     evt.preventDefault();
//   }
// };

export const handleKeyDown = (evt) => {
  if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
    evt.preventDefault();
    return;
  }

  if (
    [8, 9, 13, 27, 46, 37, 38, 39, 40].includes(evt.keyCode) ||
    ((evt.ctrlKey || evt.metaKey) && [65, 67, 86, 88].includes(evt.keyCode))
  ) {
    return;
  }

  if (
    (evt.keyCode >= 48 && evt.keyCode <= 57) ||
    (evt.keyCode >= 96 && evt.keyCode <= 105)
  ) {
    return;
  }

  if (evt.key === ".") {
    return;
  }

  evt.preventDefault();
};

// export const handleKeyDown = (evt) => {
//   // Block the keys "e", "-", and "+" from being typed
//   if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
//     evt.preventDefault();
//     return;
//   }

//   // Allow backspace, tab, enter, escape, delete, arrow keys, and common keyboard shortcuts (Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X)
//   if (
//     [8, 9, 13, 27, 46, 37, 38, 39, 40].includes(evt.keyCode) ||
//     (evt.ctrlKey === true && [65, 67, 86, 88].includes(evt.keyCode))
//   ) {
//     return;
//   }

//   // Allow digits (0-9) and numpad digits (0-9)
//   if (
//     (evt.keyCode >= 48 && evt.keyCode <= 57) ||
//     (evt.keyCode >= 96 && evt.keyCode <= 105)
//   ) {
//     return;
//   }

//   // Allow the decimal point (".") character
//   if (evt.key === ".") {
//     return;
//   }

//   // Block everything else
//   evt.preventDefault();
// };

// export const handleKeyDown = (evt) => {
//   if (evt.key === "e" || evt.key === "-" || evt.key === "+") {
//     evt.preventDefault();
//     return;
//   }
//   if (
//     [8, 9, 13, 27, 46, 37, 38, 39, 40].includes(evt.keyCode) ||
//     (evt.ctrlKey === true && [65, 67, 86, 88].includes(evt.keyCode))
//   ) {
//     return;
//   }

//   if (
//     (evt.keyCode >= 48 && evt.keyCode <= 57) ||
//     (evt.keyCode >= 96 && evt.keyCode <= 105)
//   ) {
//     return;
//   }

//   evt.preventDefault();
// };

export const truncate = (value, decimals = 2) => {
  const factor = Math.pow(10, decimals);
  return Math.trunc(value * factor) / factor;
};

export const roundToMoney = (value, decimals = 2) => {
  const multiplier = Math.pow(10, decimals);
  return Math.round(value * multiplier) / multiplier;
};

export const truncateFormat = (value, decimals = 2) => {
  return truncate(value, decimals).toFixed(decimals);
};

export const trimText = (text, limit) => {
  if (!text) return "";
  return text.length > limit ? `${text.slice(0, limit)}...` : text;
};
export const formatStringKey = (str) => {
  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
